import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetFranchisesTable, GetFranchisesTableModel, FranchisesTableParams} from 'domain/usecases';

export class RemoteGetFranchisesTable implements GetFranchisesTable {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetFranchisesTableModel>,
	) {}

	async get(params?: FranchisesTableParams): Promise<GetFranchisesTableModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
